<!--
 * @Author: xiaoxi 2767862556@qq.com
 * @Date: 2022-06-08 16:29:02
 * @LastEditors: B9NB10465295
 * @LastEditTime: 2022-07-07 16:57:10
 * @FilePath: \webpatient\src\components\hospitalSignin\szhospitalSignin\index1.vue
 * @Description: 签到
-->
<template>
  <div class="enroll">
    <div class="temp-box">
      <div class="title">感谢参与(签到)</div>
      <div class="remind">*如已报名可直接输入手机号签到*</div>
      <div class="tips">请填写相关信息：</div>
      <div class="formItem">
        <a-form-model
          :model="form"
          ref="formModel"
          style="width:300px"
          :rules="rules"
        >
          <a-form-model-item
            prop="accountPhone"
            label="手机号码："
            style="margin-bottom:0px"
          >
            <a-input v-model="form.accountPhone" placeholder="请输入手机号码" />
          </a-form-model-item>
          <a-form-model-item
            prop="accountCard"
            label="身份证号："
            style="margin-bottom:0px"
          >
            <a-input v-model="form.accountCard" placeholder="请输入身份证号" @blur="onBlur"/>
          </a-form-model-item>
          <a-form-model-item
            prop="accountSex"
            label="客户性别："
            style="margin-bottom:0px"
          >
            <a-select
              v-model="form.accountSex"
              :options="genderList"
              placeholder="请选择"
            ></a-select>
          </a-form-model-item>
          <a-form-model-item
            prop="birthDate"
            label="出生日期："
            style="margin-bottom:0px"
          >
            <a-date-picker
              v-model="form.birthDate"
              placeholder="请输入出生日期"
              style="width:300px"
            />
          </a-form-model-item>
          <a-form-model-item
            prop="accountName"
            label="姓名："
            style="margin-bottom:0px"
          >
            <a-input v-model="form.accountName" placeholder="请输入姓名" />
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="btn">
        <a-button class="submitBtn" type="primary" @click="onSubmit"
          >确认</a-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'szsignin',
  data() {
    return {
      form: {
        accountCard: '',
        accountName: '',
        accountSex: '',
        birthDate: '',
        accountPhone: '',
        campaignID: '',
      },
      rules: {
        accountPhone: [
          {
            required: true,
            message: '请输入手机号码'
          },
          {
            required: true,
            message: '手机号码格式不正确',
            pattern: /^1[0-9]{10}$/,
          },
        ],
        accountCard: [
          {
            required: false,
            message: '身份证号格式不正确',
            pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
          },
        ],
      },
      genderList: [
        {
          value: 1,
          label: '男',
        },
        {
          value: 2,
          label: '女',
        },
      ],
    }
  },
  created() {
    this.form.campaignID = this.$route.query.campaignID
  },
  methods: {
     onBlur(e){
      if(e.target.value){
        const val = e.target.value.slice(6,14);
      this.form.birthDate = moment(val)
      }
      
    },
    onSubmit() {
      this.$refs.formModel.validate().then((res) => {
        this.submit()
      })
    },
    submit() {
      let parameter = {
        ...this.form,
        birthDate:
          !this.form.birthDate
            ? ''
            : this.form.birthDate.format('YYYY/MM/DD'),
      }
      this.$API.marketSign(parameter).then((res) => {
        if (res.code == 0) {
          this.$message.success('签到成功！')
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.enroll {
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  .temp-box {
    margin-top: 50px;
    width: 300px;
    display: flex;
    flex-direction: column;
    .title {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #333333;
    }
    .remind {
      color: red;
      font-size: 19px;
      display: flex;
      justify-content: center;
    }
    .tips {
      display: flex;
      justify-content: flex-start;
      font-size: 15px;
      width: 300px;
    }
    .formItem {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
    .btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 50px;
      .submitBtn {
        width: 300px;
        border-radius: 50px;
      }
    }
  }
}
</style>
